import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';

//redux
import CertificationProcessGuide from './CertificationProcessGuide/CertificationProcessGuide';
import { icon } from 'leaflet';

const FinalDestinationCertificationProcess = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Medio Ambiente', icon: 'icon-leaf' },
		{ to: '#', label: 'Residuos', icon: 'icon-recycle' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Precertificación/Certificación de guías' links={breadcrumbLinks} icon={'icon-check-check'} />
					<CertificationProcessGuide/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default FinalDestinationCertificationProcess;